<div
  [ngClass]="{
    'calendar-red-background': type === errorMessageType.Error,
    'orange-background': type === errorMessageType.Warning,
    'calendar-blue-background': type === errorMessageType.Info
  }"
  class="error-message d-flex p-3 white-font w-100"
>
  <strong class="d-flex mr-1">
    <ng-container *ngIf="type === errorMessageType.Error">
      <i class="mr-1 far fa-exclamation-circle"></i>
      ERROR:
    </ng-container>
    <ng-container *ngIf="type === errorMessageType.Warning">
      <i class="mr-1 far fa-exclamation-triangle"></i>
      WARNING:
    </ng-container>
    <ng-container *ngIf="type === errorMessageType.Info">
      <i class="mr-1 far fa-exclamation-circle"></i>
      INFO:
    </ng-container>
  </strong>
  <div class="text-break" [innerHTML]="message | keepHtml"></div>
  <button *ngIf="showCloseButton" (click)="closed.emit(null)" class="ml-auto btn-clean white-font">
    <i class="far fa-times"></i>
  </button>
</div>
